import { helper } from '@ember/component/helper';

import { maxOne } from 'rise-ui/utils/array.js';

export default helper(function maxHelper(params) {
  return params.reduce(maxOne);
});
